module.exports = __webpack_public_path__ + "img/register.6b613225.svg";